var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconResume = function SvgIconResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.812.912c.233 0 .421.189.421.422v.613c3.114.12 5.6 2.64 5.6 5.732 0 3.169-2.611 5.738-5.833 5.738s-5.833-2.569-5.833-5.738c0-.308.254-.558.567-.558.314 0 .568.25.568.558 0 2.552 2.103 4.62 4.698 4.62s4.698-2.068 4.698-4.62c0-2.474-1.979-4.495-4.465-4.614v.597a.421.421 0 0 1-.686.327L5.11 2.825a.421.421 0 0 1 0-.654l1.437-1.165a.421.421 0 0 1 .265-.094zM6.23 5.804 8.8 7.292c.404.233.4.613 0 .845L6.23 9.625c-.403.234-.73.049-.73-.422V6.226c0-.467.33-.654.73-.422z",
    fillRule: "evenodd"
  })));
};

export default SvgIconResume;